<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="download-orders-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Download Orders
                        </h4>
                    </div>

                    <div class="modal-body">
                        <date-form-group
                                v-model="year"
                                name="year"
                                label="Year"
                                format="YYYY"
                        ></date-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-cloud-download-alt"></i> Download
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import download from 'downloadjs'
    import moment from 'moment'
    import store from '@/store'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import Errors from '@/mixins/Errors'

    export default {
        components: {DateFormGroup},

        mixins: [Errors],

        props: ['person'],

        data() {
            return {
                year: moment().format('YYYY'),
                shared: store
            }
        },

        mounted() {
            this.listenForClose()
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            submit() {
                axios.post('/api/v1/reports/ads', {year: this.year}, {
                    headers: {
                        "Authorization": "Bearer " + this.shared.token
                    },
                    responseType: "blob"
                })
                    .then(response => {
                        download(response.data, response.headers["content-disposition"].slice(22, -1))

                        $(this.$el).modal('hide')
                    })
            },

            reset() {
                this.errors = {}

                this.year = moment().format('YYYY')
            }
        }
    }
</script>
